import { useI18n } from 'vue-i18n';
import { object, string } from 'yup';

export function getValidationScheme() {
  const { t } = useI18n();
  const regex = /^\+974\s[3567]/;

  const scheme = object({
    phone: string()
      .required(t('qic.error.fill_field'))
      .min(14, t('qic.error.consist_11_digits'))
      .matches(regex, t('qic.error.qatar_rules_for_mobile')),
  });

  return scheme;
}
